// kontroll-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'ktr.title': 'Kontroll',
  'ktr.subtitle': 'Arbeid som venter på at en annen enn utføreren går god for det.',
  'ktr.view.matrix': 'Matrise',
  'ktr.view.list': 'Kontrolliste',
  'ktr.refresh': 'Oppdater',
  'ktr.notController': 'Byrået har ikke erklært deg som kontrollør. Du kan se kontrollene, men ikke godkjenne dem.',
  'ktr.empty.title': 'Ingenting til kontroll',
  'ktr.empty.text': 'En kontroll oppstår når noen sender en avstemt periode til kontroll fra avstemmingsmappa.',
  'ktr.controlNotFound': 'Fant ikke kontrollen. Har du tilgang til dette regnskapet?',
  'ktr.kpi.new': 'Nye til kontroll',
  'ktr.kpi.active': 'Under behandling',
  'ktr.kpi.awaitingPerformer': 'Venter på utfører',
  'ktr.kpi.due7': 'Frist neste 7 dager',
  'ktr.kpi.overdue': 'Frist passert',
  'ktr.kpi.approved': 'Godkjent',
  'ktr.search.placeholder': 'Søk etter klient eller org.nr',
  'ktr.search.label': 'Søk etter klient',
  'ktr.filter.allScopes': 'Alle omfang',
  'ktr.filter.allPerformers': 'Alle utført av',
  'ktr.filter.allStatuses': 'Alle statuser',
  'ktr.filter.clientGroup': 'Klientgruppe',
  'ktr.filter.allClientGroups': 'Alle klientgrupper',
  'ktr.filter.allDeadlines': 'Alle frister',
  'ktr.filter.next7Days': 'Neste 7 dager',
  'ktr.filter.onlyMine': 'Kun mine kontroller',
  'ktr.filter.onlyDeviations': 'Kun med avvik',
  'ktr.filter.reset': 'Nullstill',
  'ktr.filter.showing': 'Viser:',
  'ktr.filter.remove': 'Fjern filter',
  'ktr.history.empty': 'Ingen historikk ennå.',
  'ktr.history.system': 'Systemet',
  'ktr.history.submitted': 'sendte perioden til kontroll',
  'ktr.history.resubmitted': 'sendte inn på nytt (versjon {version})',
  'ktr.history.pointUpdated': 'vurderte et kontrollpunkt',
  'ktr.history.approved': 'godkjente kontrollen (versjon {version})',
  'ktr.history.returned': 'returnerte til utfører – {note}',
  'ktr.history.reopened': 'gjenåpnet kontrollen – {reason}',
  'ktr.history.assigned': 'tildelte kontrollen til en kontrollør',
  'ktr.history.unassigned': 'la kontrollen tilbake i køen',
  'ktr.history.documentationRequested': 'ba om dokumentasjon – {note}',
  'ktr.history.documentationResolved': 'markerte dokumentasjonen som mottatt',
  'ktr.history.basisChanged': 'regnskapet endret seg etter godkjenningen',
  'ktr.status.new': 'Ny',
  'ktr.status.underControl': 'Under kontroll',
  'ktr.status.awaitingDocs': 'Venter på dokumentasjon',
  'ktr.status.returned': 'Returnert til utfører',
  'ktr.status.resubmitted': 'Sendt inn på nytt',
  'ktr.status.approved': 'Kontrollert og godkjent',
  'ktr.status.changedAfter': 'Endret etter godkjenning',
  'ktr.action.start': 'Start kontroll',
  'ktr.action.continue': 'Fortsett kontroll',
  'ktr.action.seeStatus': 'Se status',
  'ktr.action.reviewChanges': 'Gjennomgå endringer',
  'ktr.action.seeApproved': 'Se godkjent kontroll',
  'ktr.wholePeriod': 'Hele perioden',
  'ktr.point.notAssessed': 'Ikke vurdert',
  'ktr.point.ok': 'OK',
  'ktr.point.remark': 'Merknad',
  'ktr.point.mustFix': 'Må rettes',
  'ktr.point.fromReconciliation': 'Fra avstemmingen',
  'ktr.point.sourceLine': 'Konto {account} · uforklart {amount} kr',
  'ktr.point.openSource': 'Åpne i grunnlaget',
  'ktr.point.observedPlaceholder': 'Hva er observert?',
  'ktr.fix.responsibleLabel': 'Ansvarlig for rettingen',
  'ktr.fix.responsiblePlaceholder': 'Ansvarlig …',
  'ktr.fix.deadlineLabel': 'Frist for rettingen',
  'ktr.fix.linkedPlaceholder': 'Koblet til (konto, bilag eller seksjon)',
  'ktr.fix.linkedLabel': 'Koblet til',
  'ktr.deadline.none': 'Ingen frist',
  'ktr.deadline.overdueOne': '{date} · passert med {days} dag',
  'ktr.deadline.overdueMany': '{date} · passert med {days} dager',
  'ktr.deadline.today': '{date} · i dag',
  'ktr.deadline.inOne': '{date} · om {days} dag',
  'ktr.deadline.inMany': '{date} · om {days} dager',
  'ktr.priority.high': 'Høy',
  'ktr.priority.medium': 'Middels',
  'ktr.priority.low': 'Lav',
  'ktr.reason.approverIsPerformer': 'Du kan ikke godkjenne arbeid du selv har utført. Kontroll krever en annen person.',
  'ktr.reason.approverNotController': 'Byrået har ikke erklært deg som kontrollør.',
  'ktr.reason.approverUnknown': 'Fant ikke deg som medlem av byrået.',
  'ktr.reason.alreadyApproved': 'Kontrollen er allerede godkjent.',
  'ktr.reason.returnedToPerformer': 'Kontrollen er returnert til utfører.',
  'ktr.reason.noControlPoints': 'Kontrollen har ingen punkter.',
  'ktr.reason.pointMustBeFixed': 'Minst ett punkt står som «Må rettes».',
  'ktr.reason.pointNotAssessed': 'Minst ett punkt er ikke vurdert.',
  'ktr.reason.noteMissingText': 'En merknad mangler tekst.',
  'ktr.reason.nothingToReturn': 'Ingen punkter peker på noe. Marker hva som må rettes først.',
  'ktr.reason.documentationRequestOpen': 'Dokumentforespørselen du sendte er ikke besvart ennå.',
  'ktr.reason.conclusionRequired': 'Kontrollen har avvik eller merknader. Da må konklusjonen skrives.',
  'ktr.reason.basisChangedSinceSubmit': 'Tallene har endret seg etter at arbeidet ble sendt inn. Be om en ny innsending før du godkjenner.',
  'ktr.reason.periodAreaBlocked': 'Et fagområde i perioden er ikke ferdig kontrollert.',
  'ktr.reason.assigneeUnknown': 'Fant ikke personen som medlem av byrået.',
  'ktr.reason.assigneeIsPerformer': 'Den som utførte arbeidet kan ikke settes til å kontrollere det.',
  'ktr.reason.assigneeNotController': 'Byrået har ikke erklært denne personen som kontrollør.',
  'ktr.diff.bookedBalance': 'Bokført saldo',
  'ktr.diff.unexplainedDifference': 'Uforklart differanse',
  'ktr.diff.sameNumbers': 'Tallene er de samme som forrige gang. Endringen ligger i dokumentasjonen eller forklaringene.',
  'ktr.diff.accountsChangedOne': '{count} konto endret seg',
  'ktr.diff.accountsChangedMany': '{count} kontoer endret seg',
  'ktr.diff.versionRange': 'versjon {from} → {to}',
  'ktr.diff.changed': 'Endret',
  'ktr.diff.added': 'Kom til',
  'ktr.diff.removed': 'Falt bort',
  'ktr.diff.performerReply': 'Utførerens svar',
  'ktr.diff.changedAfterApproval': 'Endret etter godkjenningen',
  'ktr.diff.resubmittedWhatChanged': 'Sendt inn på nytt — hva som endret seg',
  'ktr.diff.reopenAndRecheck': 'Gjenåpne og kontroller på nytt',
  'ktr.col.priority': 'Prioritet',
  'ktr.col.client': 'Klient',
  'ktr.col.period': 'Periode',
  'ktr.col.scope': 'Omfang',
  'ktr.col.performedBy': 'Utført av',
  'ktr.col.sentTitle': 'Sendt til kontroll',
  'ktr.col.sent': 'Sendt',
  'ktr.col.deviationsTitle': 'Kritiske avvik',
  'ktr.col.deviations': 'Avvik',
  'ktr.col.progressTitle': 'Kontrollfremdrift',
  'ktr.col.progress': 'Fremdrift',
  'ktr.col.assignedTitle': 'Tildelt kontrollør',
  'ktr.col.assigned': 'Tildelt',
  'ktr.col.deadlineTitle': 'Kontrollfrist',
  'ktr.col.deadline': 'Frist',
  'ktr.col.status': 'Status',
  'ktr.col.periodApproval': 'Periodegodkjenning',
  'ktr.notAssigned': 'Ikke tildelt',
  'ktr.assignedControllerFor': 'Tildelt kontrollør for {name}',
  'ktr.overdueShort': 'passert',
  'ktr.progressCount': '{done} av {total}',
  'ktr.noControlsMatch': 'Ingen kontroller matcher filtrene.',
  'ktr.noClientsMatch': 'Ingen klienter matcher filtrene.',
  'ktr.orgNumber': 'Org. {org}',
  'ktr.noOrgNumber': 'Uten org.nr.',
  'ktr.open': 'Åpne',
  'ktr.openControl': 'Åpne kontroll',
  'ktr.cell.notSent': 'Ikke sendt til kontroll',
  'ktr.cell.performedBy': 'Utført av {email}',
  'ktr.cell.assigned': 'Tildelt {name}',
  'ktr.cell.deadline': 'Frist {deadline}',
  'ktr.cell.critical': '{count} kritiske avvik',
  'ktr.cell.version': 'Versjon {version}',
  'ktr.period.notSent': 'Ikke sendt',
  'ktr.period.partlySent': 'Delvis sendt',
  'ktr.period.blocked': 'Blokkert',
  'ktr.period.ready': 'Klar for periodegodkjenning',
});
